// Import the functions you need from the SDKs you need
//import { initializeApp } from "firebase/app";
//import { getFirestore, collection, getDoc, doc } from 'firebase/firestore/lite';
import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDfdoNa5uh5IvM8KQyTjM4Ypr9ScwPWf_E",
  authDomain: "paws-near-me.firebaseapp.com",
  projectId: "paws-near-me",
  storageBucket: "paws-near-me.appspot.com",
  messagingSenderId: "824928569051",
  appId: "1:824928569051:web:7adf23ced36b2735d1eefe"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

//1
export const allPaws = () => {

  const pawsRef = db.collection('paws');
  const paws = pawsRef.get();
  return paws;
};

//2
export const countPaws = () => {

  const pawsRef = db.collection('paws');
  const paws = pawsRef.get();
  return paws.size;
};

//3
export const retrieveShelterInfo = async (shelterID) => {
  console.log("retrieve");
  const shelterRef = db.collection('shelters').doc(shelterID);
  const shelterInfo =  await shelterRef.get();
  return shelterInfo;
};

//4
const handleSpeciesFilters = (pawsRef,filterArray) => {
  const speciesArray = new Array(2).fill("");

  if(filterArray[0]){
    speciesArray[0] = "Cat";
  }
  if(filterArray[1]){
    speciesArray[1] = "Dog";
  }
  const pawsfilteredRef = pawsRef.where('species', "in", speciesArray)
  const filteredPaws = pawsfilteredRef.get();
  return filteredPaws;
}


//5
const handleBreedFilters = (pawsRef,filterArray) => {
  const breedArray = new Array(8).fill("");

  if(filterArray[2]){
    breedArray[0] = "Domestic Short Hair"
  }
  if(filterArray[3]){
    breedArray[1] = "Domestic Long Hair"
  }
  if(filterArray[4]){
    breedArray[0] = "Domestic Short Hair"
    breedArray[1] = "Domestic Long Hair"
    const pawsfilteredRef = pawsRef.where('breed', "not-in", breedArray).where('species', "==", "Cat");
    const filteredPaws = pawsfilteredRef.get();
    return filteredPaws;
  }
  if(filterArray[5]){
    breedArray[2] = "Terrier"
  }
  if(filterArray[6]){
    breedArray[3] = "Pit Bull"
  }
  if(filterArray[7]){
    breedArray[4] = "Labrador Retriever"
  }
  if(filterArray[8]){
    breedArray[5] = "German Shepherd"
  }
  if(filterArray[9]){
    breedArray[6] = "Hound"
  }
  if(filterArray[10]){
    breedArray[7] = "Mixed Breed"
  }
  if(filterArray[11]){
    breedArray[2] = "Terrier"
    breedArray[3] = "Pit Bull"
    breedArray[4] = "Labrador Retriever"
    breedArray[5] = "German Shepherd"
    breedArray[6] = "Hound"
    breedArray[7] = "Mixed Breed"
    const pawsfilteredRef = pawsRef.where('breed', "not-in", breedArray).where('species', "==", "Dog");
    const filteredPaws = pawsfilteredRef.get();
    return filteredPaws;

  }
  const pawsfilteredRef = pawsRef.where('breed', "in", breedArray)
  const filteredPaws = pawsfilteredRef.get();
  return filteredPaws;
}

//6
const handleSexFilters = (pawsRef, filterArray) => {
  const sexArray = new Array(2).fill("");

  if(filterArray[12]){
    sexArray[0] = "M"
  }
  if(filterArray[13]){
    sexArray[1] = "F"
  }
  const pawsfilteredRef = pawsRef.where('sex', "in", sexArray)
  const filteredPaws = pawsfilteredRef.get();
  return filteredPaws;
}

//7
const handleSizeFilters = (pawsRef, filterArray) => {
  const sizeArray = new Array(3).fill("");
  if(filterArray[14]){
    sizeArray[0] = "Small"
  }
  if(filterArray[15]){
    sizeArray[1] = "Medium"
  }
  if(filterArray[16]){
    sizeArray[2] = "Large"
  }
  const pawsfilteredRef = pawsRef.where('weight', "in", sizeArray)
  const filteredPaws = pawsfilteredRef.get();
  return filteredPaws;
}

//8
const handleAgeFilters = (pawsRef, filterArray) => {
  const ageArray = new Array(4).fill("");

  if(filterArray[17]){
    ageArray[0] = "Baby"
  }
  if(filterArray[18]){
    ageArray[1] = "Young"
  }
  if(filterArray[19]){
    ageArray[2] = "Adult"
  }
  if(filterArray[20]){
    ageArray[3] = "Senior"
  }
  const pawsfilteredRef = pawsRef.where('age', "in", ageArray)
  const filteredPaws = pawsfilteredRef.get();
  return filteredPaws;
}

//9
const handleShelterFilters = (pawsRef, filterArray) => {
  const shelterArray = new Array(3).fill("");
  
  if(filterArray[21]){
    shelterArray[0] = "S1"
  }
  if(filterArray[22]){
    shelterArray[1] = "S2"
  }
  if(filterArray[23]){
    shelterArray[2] = "S3"
  }
  const pawsfilteredRef = pawsRef.where('shelterId', "in", shelterArray)
  const filteredPaws = pawsfilteredRef.get();
  return filteredPaws;
}

//Nasty and innefficent 
export const handleFilters = (filterArray) => {
  const pawsRef = db.collection('paws');

  if(filterArray[0] || filterArray[1]){
    const speciesfilter = handleSpeciesFilters(pawsRef, filterArray);
    return speciesfilter;
  }else if(filterArray[2] || filterArray[3] || filterArray[4] || filterArray[5] || filterArray[6] || filterArray[7] || filterArray[8] || filterArray[9] || filterArray[10] || filterArray[11]){
    const breedFilter = handleBreedFilters(pawsRef, filterArray);
    return breedFilter;
  }else if(filterArray[12] || filterArray[13]){
    const sexfilter = handleSexFilters(pawsRef, filterArray);
    return sexfilter;
  }else if(filterArray[14] || filterArray[15] || filterArray[16]){
    const sizefilter = handleSizeFilters(pawsRef, filterArray);
    return sizefilter;
  }else if(filterArray[17] || filterArray[18] || filterArray[19] || filterArray[20]){
    const agefilter = handleAgeFilters(pawsRef, filterArray);
    return agefilter;
  }else if(filterArray[21] || filterArray[22] || filterArray[23]){
    const shelterfilter = handleShelterFilters(pawsRef, filterArray);
    return shelterfilter;
  }
  
  const filteredPaws = allPaws();
  return filteredPaws;
};

//10
export const handleSearch = (searchKey) => {
  const pawsRef = db.collection('paws');
  const pawsSearchedRef = pawsRef.where('name', "==", searchKey)
  const filteredPaws = pawsSearchedRef.get();
  return filteredPaws;
}

export default{
  allPaws, countPaws, handleFilters, handleSearch
};
